import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import { buttonName, demoAccount } from "../../locales/en";
import Style from "./modal.module.scss";

const DemoAccInfoModal = ({ isOpen, toggle }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title=""
      modalClassName={`${Style.xeroModal} modal-dialog-centered modal-lg`}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0`}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-primary",
          onClick: toggle
        }
      ]}
    >
      <div className="inv-upload-template">
        <div className={`${Style.manul_Invoice_Submit}`}>
          <p>{demoAccount?.p6}</p>
          <p>{demoAccount?.p7}</p>
        </div>
      </div>
    </CommonModal>
  );
};

DemoAccInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default DemoAccInfoModal;
